// Wave 44 — minimal hand-rolled iconography.
//
// Heroicons-style outline icons used across the studio. Sized via the
// `--icon-sm/md/lg/xl` tokens. Single-color stroke so they pick up the
// surrounding `currentColor`. Inline SVG (no font / sprite sheet) so the
// payload is small and there's no FOUC.
//
// Why not import @heroicons/react: the studio's icon needs are small
// (under 30 unique icons across the app today). Bringing in a 200kb
// dependency for ~15 icons is wasteful. New icons land here as needed.

const SIZE_VAR = {
  sm: 'var(--icon-sm)',
  md: 'var(--icon-md)',
  lg: 'var(--icon-lg)',
  xl: 'var(--icon-xl)',
}

function Svg({ children, size = 'md', label, ...rest }) {
  const px = SIZE_VAR[size] || size
  return (
    <svg
      role={label ? 'img' : 'presentation'}
      aria-label={label}
      aria-hidden={label ? undefined : 'true'}
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      {children}
    </svg>
  )
}

// Bell — used by NotificationBell.
export function BellIcon(props) {
  return (
    <Svg {...props}>
      <path d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
    </Svg>
  )
}

// Chevron — palette / drawer toggles.
export function ChevronRightIcon(props) {
  return (
    <Svg {...props}>
      <path d="m8.25 4.5 7.5 7.5-7.5 7.5" />
    </Svg>
  )
}

export function ChevronDownIcon(props) {
  return (
    <Svg {...props}>
      <path d="m19.5 8.25-7.5 7.5-7.5-7.5" />
    </Svg>
  )
}

// Search — palette + filters.
export function SearchIcon(props) {
  return (
    <Svg {...props}>
      <path d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
    </Svg>
  )
}

// Check — confirmation, success states.
export function CheckIcon(props) {
  return (
    <Svg {...props}>
      <path d="m4.5 12.75 6 6 9-13.5" />
    </Svg>
  )
}

// X — close, dismiss.
export function XMarkIcon(props) {
  return (
    <Svg {...props}>
      <path d="M6 18 18 6M6 6l12 12" />
    </Svg>
  )
}

// Sparkle / star — voice, calibration.
export function SparkleIcon(props) {
  return (
    <Svg {...props}>
      <path d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z" />
      <path d="M18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456Z" />
    </Svg>
  )
}

// Shield — brand safety.
export function ShieldIcon(props) {
  return (
    <Svg {...props}>
      <path d="M9 12.75 11.25 15 15 9.75M21 12c0 4.566-4.06 8.282-9 9-4.94-.718-9-4.434-9-9V5.25l9-3 9 3V12Z" />
    </Svg>
  )
}

// Bolt — autonomy / live publish.
export function BoltIcon(props) {
  return (
    <Svg {...props}>
      <path d="M3.75 13.5 13.5 3 12 10.5h7.5L9 21l1.5-7.5h-6.75Z" />
    </Svg>
  )
}

// Arrow uturn left — undo.
export function UndoIcon(props) {
  return (
    <Svg {...props}>
      <path d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
    </Svg>
  )
}
